import type { Locale } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute, NoPathParams } from "../../api"
import type { InteriorView } from "../../common/colors/interiorColor/InteriorView"

export interface SetManualInteriorQueryParams {
	"inventory-id": string
	"market-languages": Locale[]
}

export interface ManualInteriorChange {
	cockpitColorHexCode?: string
	materialKey: string
	name: Record<string, string>
	seatColorHexCode: string
	tagKey: string
}

export const setManualInteriorRoute: ApiRoute<
	NoPathParams,
	SetManualInteriorQueryParams,
	ManualInteriorChange,
	InteriorView
> = {
	buildUrl: () => "/colors/interior/manual",
	method: "post",
	path: "/colors/interior/manual",
}
